<template>
  <div class="tolead">
    <div class="title" style="display: flex;justify-content: space-between;">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 20px;margin-top: 20px;">
        <el-breadcrumb-item :to="{ path: '/report' }">工作汇报</el-breadcrumb-item>
        <el-breadcrumb-item>患者详情</el-breadcrumb-item>
      </el-breadcrumb>

      <el-button type="primary" style="margin-top: 20px;margin-right: 20px;" @click="$router.go(-1)">返回</el-button>
    </div>
    <div class="content">
      <div class="con">
        <el-table ref="multipleTable" :data="PatientTable" style="width: 98%; margin: 0 auto; overflow: hidden !important"
          height="100%" :header-cell-style="{
            'text-align': 'center',
            background: 'rgb(240, 247, 253)',
          }" border @select="selectAll" @select-all="arrselectAll">
          <!-- @select-all="selectAll" 
            @selection-change="handleActivitySelectionChange" -->
          <el-table-column type="selection" min-width="30" align="center">
          </el-table-column>
          <el-table-column v-if="admin == '00000000-0000-0000-0000-000000000000'" prop="OrganizationName" label="组织名称"
            min-width="80" align="center">
          </el-table-column>
          <el-table-column label="项目编号" min-width="60" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.ProjectName" placement="top">
                <p>{{ scope.row.ProjectNo }}</p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="No" label="患者编号" min-width="60" align="center">
          </el-table-column>
          <el-table-column label="电话" min-width="110" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.Tel }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RiskRating" :sortable="true" :sort-method="sortByRisk" label="风险" min-width="80"
            align="center">
            <template slot-scope="scope">
              <!-- <el-tag
                  :color="
                    scope.row.RiskRating == '01' || scope.row.RiskRating==null
                      ? '#3fbc39'
                      : scope.row.RiskRating == '02'
                      ? '#f6d10e'
                      : scope.row.RiskRating == '03'
                      ? '#fd9133'
                      : scope.row.RiskRating == '04'
                      ? '#ff3f3f'
                      : ''
                  "
                  effect="dark"
                  disable-transitions
                ></el-tag> -->
              <img v-if="scope.row.RiskRating == '01' || scope.row.RiskRating == null
                " src="../../assets/image/RisiSafe.png" style="width: 20px; height: 20px" />
              <img v-if="scope.row.RiskRating == '02'" src="../../assets/image/RisiWarn.png"
                style="width: 20px; height: 20px" />
              <img v-if="scope.row.RiskRating == '03'" src="../../assets/image/RisiWarning.png"
                style="width: 20px; height: 20px" />
              <img v-if="scope.row.RiskRating == '04'" src="../../assets/image/RisiDanger.png"
                style="width: 20px; height: 20px" />
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="姓名" :sortable="true" :sort-method="sortByVesselName" min-width="100px"
            align="center" fixed>
          </el-table-column>

          <el-table-column label="证件号" min-width="200" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.CertNo }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="AttendingDoctor" label="主治医师" min-width="70" align="center">
            </el-table-column> -->
          <el-table-column label="性别" min-width="100" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.Sex == 1 ? "男" : "" }}</p>
              <p>{{ scope.row.Sex == 0 ? "女" : "" }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="Age" label="年龄" sortable min-width="100" align="center">
          </el-table-column>
          <el-table-column prop="Birthday" label="出生日期" sortable min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="DischargeDiagnosis" label="出院诊断" min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="SecondaryDiagnosis" label="次要诊断" min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" sortable min-width="180" align="center">
          </el-table-column>
          <el-table-column label="患者标签" min-width="100" align="center">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.LabelNameList" :key="index" class="tag_span">
                {{ item }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="RandomNumber" label="随机号" min-width="100" align="center">
          </el-table-column>
          <el-table-column prop="GroupNumber" label="组别号" min-width="100" align="center">
          </el-table-column>
          <!-- 随访记录 -->
          <!-- <el-table-column prop="PatientLabel" label="随访详情" min-width="100" align="center" fixed="right">
               <template slot-scope="scope">
                    <el-link
                    :underline="false"
                    @click="FollowUpRecords(scope.row)"
                  >随访记录</el-link>
               </template>
            </el-table-column> -->
          <!-- 患者头像 -->
          <!-- <el-table-column prop="patient" label="患者画像" width="100" align="center" fixed="right">
              <template slot-scope="scope">
                <img  @click="PatientPortrait(scope.row)" src="../../assets/image/icon/patient-touxiang.png" alt=""
                >
              </template>
            </el-table-column> -->

          <!-- <el-table-column prop="patient" label="患者画像" width="90" align="center">
              <template slot-scope="scope">
                <img  @click="PatientPortrait(scope.row)" src="../../assets/image/icon/patient-touxiang.png">
              </template
              >
            </el-table-column> -->
          <!-- 问卷填写 -->
          <!-- <el-table-column prop="PatientLabel" label="填写问卷" min-width="100" align="center"  v-if="admin!='00000000-0000-0000-0000-000000000000'" fixed="right">
               <template slot-scope="scope">
                    <el-link
                    :underline="false"
                    @click="QuestionnaireFilling(scope.row)"
                  >问卷填写</el-link
                  >
               </template>
            </el-table-column> -->
          <el-table-column label="操作" :min-width="!devicePixelRatio ? '250' : '140'" class="edit-info"
            v-if="admin != '00000000-0000-0000-0000-000000000000'" fixed="right">
            <template slot-scope="scope">
              <!-- <el-link-->
              <!--                style="margin-right: 14px"-->
              <!--                :underline="false"-->
              <!--                @click="information(scope.$index, scope.row)"-->
              <!--              ><i class="el-icon-edit-outline"></i>修改</el-link -->
              <!--              > -->
              <div style="
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: space-between;
                  padding: 0 10px;
                ">
                <!-- v-has="'Patient/Edt'" -->
                <el-link :underline="false" @click="QuestionnaireFilling(scope.row)" style="">
                  <div style="display: flex; align-items: center">
                    <img style="width: 16px; height: 16px; margin-top: 2px" src="../../assets/image/icon/FillIn2.png"
                      alt="" />
                    新增问卷
                  </div>
                </el-link>
                <el-link :underline="false" @click="FollowUpRecords(scope.row)" style="">
                  <div style="display: flex; align-items: center">
                    <img style="width: 16px; height: 16px; margin-top: 3px" src="../../assets/image/icon/takeNotes1.png"
                      alt="" />
                    随访记录
                  </div>
                </el-link>
                <el-link @click="PatientPortrait(scope.row)" :underline="false" style="">
                  <div style="display: flex; align-items: center">
                    <img style="width: 16px; height: 16px; margin-top: 1px"
                      src="../../assets/image/icon/PatientPortrait2.png" alt="" />
                    患者画像
                  </div>
                </el-link>
                <el-link @click="AddPatientDialog(scope.row)" type="primary" :underline="false"><i
                    class="el-icon-edit-outline"></i>修改</el-link>
                <el-link :underline="false" style="" @click="DeletePatient(scope.row)"><i
                    class="el-icon-delete"></i>删除</el-link>

                <!-- <el-link  style="margin-left: 11px" @click="AddRobotIdDialog(scope.row)" type="primary" :underline="false"><i class="el-icon-phone-outline"></i>拨打</el-link> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 98%; margin: 0 auto">
        <Pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.rows"
          @pagination="ProjectGetPageList(value.Id)"></Pagination>
      </div>
      <add-patient :type="2" @EditSonToFather="Editfather" :item="PatientList" v-if="dialogFlag"
        :dialog="dialogFlag"></add-patient>
      <div class="QuestionnaireTable">
        <el-dialog :visible.sync="dialogVisible" width="30%">
          <div slot="title">
            <span style="color: #fff">问卷填写</span>
          </div>
          <div>
            <p style="font-size: 16px; margin-bottom: 10px">问卷列表</p>
            <el-select v-model="Qval" placeholder="请选择" @change="QuestionnaireTableChange" style="margin-bottom: 10px">
              <el-option v-for="(item, index) in QuestionnaireTable" :key="index" :label="item.questionnaireName"
                :value="item.Id">
              </el-option>
            </el-select>
          </div>
          <div style="width: 100%">
            <p style="font-size: 16px; margin-bottom: 10px">访视次数</p>
            <el-input v-model="CObj" placeholder="请输入内容"></el-input>
          </div>
          <div slot="footer" class="btn">
            <button @click="dialogVisible = false">取 消</button>
            <button type="primary" @click="determine">确 定</button>
          </div>
        </el-dialog>
      </div>
      <div class="QuestionnaireFilling">
        <el-dialog :visible.sync="QuestionnaireFillingDialog" fullscreen>
          <iframe :src="Url" frameborder="0" width="100%" height="100%" ref="myFrame"></iframe>
        </el-dialog>
      </div>
      <el-drawer :visible.sync="detailsDrawer" direction="rtl" :wrapperClosable="false" size="1920px">
        <div slot="title" class="header-title">
          <i class="el-icon-right" style="font-size: 20px; margin-left: 16px; margin-right: 21px"
            @click="detailsDrawer = false"></i>
          <span style="margin-right: 237px">随访记录</span>
          <span>随访详情</span>
        </div>
        <div class="detailsDrawer-components">
          <task-details :ProjectObj="ProjectObj" :PObj="PObj" v-if="detailsDrawer"></task-details>
        </div>
      </el-drawer>
      <div class="QuestionnaireTable">
        <el-dialog :visible.sync="PdialogVisible" :width="devicePixelRatio ? '30%' : '60%'">
          <div slot="title">
            <span style="color: #fff">批量导入</span>
          </div>
          <div>
            <p style="font-size: 16px; margin-bottom: 10px">项目列表</p>
            <el-select v-model="Pvalue" placeholder="请选择">
              <el-option v-for="(item, index) in QProject" :key="index" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </div>
          <div slot="footer" class="btn">
            <button @click="PdialogVisible = false">取 消</button>
            <button type="primary" @click="Pdetermine">确 定</button>
          </div>
        </el-dialog>
      </div>
      <div class="QuestionnaireTable">
        <el-dialog :visible.sync="robotVisible" :width="!devicePixelRatio ? '30%' : '60%'">
          <div slot="title">
            <span style="color: #fff">拨打</span>
          </div>
          <div>
            <p style="font-size: 16px; margin-bottom: 10px">机器人列表</p>
            <el-select v-model="obj.RobotId" placeholder="请选择" maxlength="10" minlength="2">
              <el-option v-for="(item, index) in ruleLIst" :key="index" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </div>
          <div slot="footer" class="btn">
            <button @click="robotVisible = false">取 消</button>
            <button type="primary" @click="ExecuteOnce">确 定</button>
          </div>
        </el-dialog>
      </div>
      <!-- <div style="margin-left: 15px;margin-top: 10px">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="this.count"
            :page-size="this.num"
            :current-page="this.corr"
            @current-change="handle"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div> -->
    </div>
  </div>
</template>
<script>
import TaskDetails from "../../components/task/TaskDetails.vue";
import AddPatient from "@/components/PatientList/AddPatient"; //打开新增患者
import AddLabel from "@/components/PatientList/AddLabel";
import PatientCenter from "@/api/PatientCenter";
import ProjectManagement from "../../api/ProjectManagement";
import derive from "../../api/derive.js";
import questionnaire from "../../api/questionnaire.js";
import { local } from "../../utils/storage";
import Pagination from "../../components/Pagination/index.vue";
import { mapState } from "vuex";
import WorkReport from "../../api/WorkReport";
// import Vconsole from 'vconsole';
export default {
  data() {
    return {
      obj: {
        ProjectId: "",
        RobotId: "",
        ProjectPatientIds: [],
      },
      robotVisible: false,
      PdialogVisible: false,
      Pvalue: "",
      admin: local.get("UserId"),
      PatientList: "",
      detailsDrawer: false,
      QuestionnaireFillingDialog: false,
      PatientTable: [],
      StartTime: "", //开始时间
      EndTime: "", //结束时间
      keyword: "", //关键字
      Excel: [],
      Project: [
        {
          Name: "全部",
          Id: "all",
        },
        {
          Name: "其他",
          Id: "other",
        },
      ],
      value: "", //项目id
      dialogVisible: false,
      QuestionnaireTable: [],
      ItemList: [],
      Qval: "",
      PObj: "", //储存患者对象
      CObj: "", //随访次数对象
      Url: "",
      ProjectObj: {},
      total: 0,
      listQuery: {
        Key: "",
        page: 1,
        rows: 10,
      },
      activityMultipleSelection: [],
      ruleLIst: [], //机器人列表,
      QProject: [],
      border: 0,
      devicePixelRatio: false,
      direction: false,
      flag: false,
      scrollTop: 0,
      scrollLeft: 0,
    };
  },
  computed: mapState(["dialogFlag"]),
  mounted() {
    this.devicePixelRatio = document.documentElement.clientWidth < 1100;

    //     var startX,startY;
    //     document.addEventListener("touchstart",function(e){
    //       document.getElementsByClassName('el-table__body-wrapper')[0].style.overflowY = 'visible';
    //       document.getElementsByClassName('el-table__body-wrapper')[0].style.overflowX = 'auto';
    //       startX = e.targetTouches[0].pageX;
    //       startY = e.targetTouches[0].pageY;
    //     });

    // document.addEventListener("touchmove",function(e){
    //   console.log(e)

    //   if(this.flag) {
    //     let direction = this.direction ? 'overflowX' : 'overflowY';
    //     document.getElementsByClassName('el-table__body-wrapper')[0].style[direction] = 'hidden';
    //     return
    //   }

    //   var moveX = e.targetTouches[0].pageX;
    //   var moveY = e.targetTouches[0].pageY;
    //   this.flag = true

    // if(Math.abs(moveX-startX)<Math.abs(moveY-startY)){
    //   this.direction = true
    // }else {
    //   this.direction = false
    // }
    // },{passive:false});

    // document.addEventListener("touchend",function(e){
    //     this.flag = false;
    // });
  },
  created() {
    //     new Vconsole();

    this.value = {
      Id: "all",
      Name: "全部",
    };
    this.ProjectList();
  },
  components: { AddPatient, TaskDetails, Pagination },
  methods: {
    sortByVesselName(obj1, obj2) {
      if (
        [obj1.Name, obj2.Name][0] ==
        [obj1.Name, obj2.Name].sort((a, b) =>
          a.localeCompare(b, "zh", { sensitivity: "accent" })
        )[0]
      ) {
        return -1;
      } else {
        return 1;
      }
    },
    sortByRisk(obj1, obj2) {
      if (obj2.RiskRating > obj1.RiskRating) {
        return 1;
      } else {
        return -1;
      }
      // console.log(obj1.RiskRating)
    },
    dialAll() {
      if (this.obj.ProjectId == "") {
        this.border = 1;
        return this.$message({
          message: "请先在被选中的红色框中选择一个项目",
          type: "warning",
        });
      }
      if (this.activityMultipleSelection.length == 0) {
        return this.$message({
          message: "请先勾选一个患者",
          type: "warning",
        });
      }
      //新增打开对话框清空obj.RobitId
      this.obj.RobotId = "";
      this.GetRobotList(this.obj.ProjectId);
      this.robotVisible = true;
    },
    TemplateDownload() {
      ProjectManagement.TemplateDownloadData().then((res) => {
        if (res.data.Status == 1) {
          this.downLoad(res.data.Data);
        } else {
          alert(res.data.Message);
        }
      });
    },
    downLoad(record) {
      // console.log('record.httpAddress: ', record.httpAddress)
      const link = document.createElement("a");
      //_blank表示在新窗口打开链接
      link.target = "_blank";
      link.href = record;
      document.body.appendChild(link);
      link.click();
      // document.body.removeChild(link) // 下载完成移除元素
    },
    AddRobotIdDialog(row) {
      this.obj.ProjectId = row.ProjectId;
      this.obj.ProjectPatientId = row.Id;
      this.GetRobotList(row.ProjectId);
      this.robotVisible = true;
    },
    //拨打
    ExecuteOnce() {
      if (this.obj.RobotId == "") {
        return this.$message({
          message: "请选择一个机器人",
          type: "warning",
        });
      }
      this.activityMultipleSelection.forEach((item) => {
        this.PatientTable.forEach((p) => {
          if (p.Id == item.Id) {
            this.obj.ProjectPatientIds.push(p.Id);
          }
        });
      });
      ProjectManagement.ExecuteOnceData(this.obj).then((res) => {
        if (res.data.Status == 1) {
          this.ProjectList();
          this.$message({
            type: "success",
            message: "拨打成功!",
          });
          this.robotVisible = false;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //机器人列表
    GetRobotList(ProjectId) {
      ProjectManagement.GetRobotListData(ProjectId).then((res) => {
        if (res.data.Status == 1) {
          this.ruleLIst = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },
    AddPatientDialog(row) {
      this.$store.commit("dialogFlagFn", true);
      this.PatientList = row;
    },
    PatientPortrait(row) {
      this.$router.push({
        path: "/PatientPortrait",
        query: { Id: this.$route.query.Id, qId: row.Id },
      });
    },
    DelFn(data) {
      this.PatientTable.forEach((item) => {
        if (item.Id == data.ProjectPatientId) {
          item.LabelNameList = item.LabelNameList.filter((row) => {
            return row != data.Name;
          });
        }
      });
    },
    AddFn(data) {
      this.PatientTable.forEach((row) => {
        if (row.Id == data.ProjectPatientId) {
          row.LabelNameList.push(data.Name);
        }
      });
    },
    //选中方法
    // handleActivitySelectionChange(selection){
    //     //this.activityMultipleSelection自己定义的接受数组
    //   this.activityMultipleSelection = selection
    //   if (selection.length > 1) {
    //     let del_row = selection.shift()
    //     this.$refs.multipleTable.toggleRowSelection(del_row, false)
    //   }
    // },
    //判断选中数量
    selectAll(selection) {
      this.obj.ProjectPatientIds = [];
      this.activityMultipleSelection = selection;
      //  selection.forEach(item=>{
      //     this.obj.ProjectPatientIds.push(item.Id)
      //  })
    },
    arrselectAll(selection) {
      this.obj.ProjectPatientIds = [];
      this.activityMultipleSelection = selection;
    },
    //打开随访记录弹框
    FollowUpRecords(row) {
      this.PObj = row;
      this.$store.commit("SubmenuFn", true);
      this.detailsDrawer = true;
    },
    //userId="患者id"
    //userName="患者名字"
    //fillinId="登录人id"
    //fillinName="登录人姓名"
    //phone="电话"
    //visitsNumber="方式次数"
    determine() {
      if (this.Qval != "") {
        // let Frq=null
        // if(this.CObj.Frq==null){
        //     Frq=0
        // }else{
        //     Frq=this.CObj.Frq
        // }
        this.QuestionnaireFillingDialog = true;
        this.dialogVisible = false;
        this.Url = `${window.global_config.BASE_URL1}/#/P?sysData=${this.PObj.CallBackInfo.CallBackParameterEncrypt}&type=1&qid=${this.Qval}&userId=${this.PObj.Id}&userName=${this.PObj.Name}&fillinId=${local.get("UserId")}&fillinName=${local.get("UserName")}&phone=${this.PObj.Tel}&visitsNumber=${this.CObj}`;
        // const parameter={
        //     ProjectId:this.PObj.ProjectId
        // }
        // console.log(this.PObj);
        // questionnaire.CallBackQuestionnaireData(parameter).then(res=>{
        //             console.log(res,"xxxxx");
        //             // let a=JSON.parse(res.data.Data)
        //             // console.log(a.ProjectId);
        //             if(res.data.Status==1){
        //                   this.QuestionnaireFillingDialog=true
        //                   this.dialogVisible=false
        //                   this.Url=`${window.global_config.BASE_URL1}/#/P?sysData=${res.data.Data}&type=1&qid=${this.Qval}&userId=${this.PObj.Id}&userName=${this.PObj.Name}&fillinId=${local.get('UserId')}&fillinName=${local.get('UserName')}&phone=${this.PObj.Tel}&visitsNumber=${this.CObj}`
        //             }else{
        //                 alert(res.data.Message)
        //             }
        // })
      }
    },
    //选择问卷后调用随访接口
    QuestionnaireTableChange(e) {
      if (e.issueState == false) {
        this.Qval = "";
        alert("请先去发布问卷");
      }
    },
    //项目选择后的回调
    ProjectChange(item) {
      this.obj.ProjectId = "";
      if (item.Id == "all" || item.Id == "other") {
        local.set("IsRtc", true);
      } else {
        this.obj.ProjectId = item.Id;
        local.set("IsRtc", item.IsRtc);
      }
      this.ProjectGetPageList(item.Id);
    },
    //项目
    async ProjectList() {
      derive.ProjectListData().then((res) => {
        if (res.data.Status == 1) {
          if (res.data.Data.length != 0) {
            this.QProject = JSON.parse(JSON.stringify(res.data.Data));
            // this.Project=res.data.Data;
            //初始化Project
            this.Project = [
              {
                Name: "全部",
                Id: "all",
              },
              {
                Name: "其他",
                Id: "other",
              },
            ];
            res.data.Data.forEach((item) => {
              this.Project.push(item);
            });

            // let Objall={
            //     Name:"全部",

            //     Id:"all",
            // }
            // let ObjOther={
            //     Name:"其他",
            //     Id:"other",
            // }
            this.value = {
              Id: "all",
              Name: "全部",
            };
            local.set("IsRtc", true);
            // this.Project.unshift(ObjOther)
            // this.Project.unshift(Objall)
            this.ProjectGetPageList(this.value.Id);
          }
        } else {
          alert(res.data.Message);
        }
      });
    },
    //打开问卷填写
    QuestionnaireFilling(row) {
      this.$confirm("是否新增一份问卷？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (!row.CallBackInfo.IsSuccess) {
          alert(row.CallBackInfo.Msg);
          return;
        }
        if (row.ProjectId == null) {
          alert("该患者不属于任何项目,无法填写问卷");
        } else {
          this.PObj = row;
          this.dialogVisible = true;
          this.Url = "";
          this.Qval = "";
          this.QuestionnaireGetPageList(row.ProjectId);
        }
      });
    },
    //问卷列表分页
    QuestionnaireGetPageList(ProjectId) {
      const parameter = {
        ProjectId: ProjectId,
      };
      derive.CRFSurfaceData(parameter).then((res) => {
        if (res.data.Status == 1) {
          this.QuestionnaireTable = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //重置
    Reset() {
      // this.value.Id = 'all';
      // this.value.Name = '全部';
      this.value = this.Project[0];
      this.listQuery.Key = "";
      this.keyword = "";
      this.StartTime = "";
      this.EndTime = "";
      this.ProjectGetPageList("all");
    },
    //搜索GetPageList
    query() {
      this.listQuery.Key = this.keyword;
      this.listQuery.page = 1;
      this.ProjectGetPageList(this.value.Id);
    },
    //打开导入
    chooseFile() {
      this.$refs.file.value = "";
      this.Pvalue = "";
      this.PdialogVisible = true;
    },
    Pdetermine() {
      this.PdialogVisible = false;
      this.$refs.file.click();
    },
    // 思路：对于原数组每个对象来说
    //    （1） 找出所有的中文key
    //     (2)  得到对应的英文key
    //     (3)  拼接一个新对象： 英文key:值
    transExcel(results) {
      // 首先需要一个我们写好的用来映射的对象或数组
      const mapInfo = {
        患者编号: "No",
        医保卡号: "MiCardNo",
        "患者姓名（必填）": "Name",
        名字缩写: "NameAbbr",
        "就诊日期（日期格式2020-09-25）": "VisitDate",
        "患者电话（必填）": "Tel",
        "证件类型（00=身份证 01=军官证 02=护照 03=其它）请填写对应的数字":
          "CertType",
        证件号码: "CertNo",
        "出生日期（日期格式2020-09-25）": "Birthday",
        年龄: "Age",
        "性别（1=男 0=女）请填写对应的数字": "Sex",
        "身高（cm）": "Height",
        "体重（kg）": "Weight",
        "教育程度（00=文盲 01=小学 02=初中 03=中专及高中 04=大专 05=本科 06=硕士及以上）请填写对应的数字":
          "Edu",
        患者微信: "WX",
        患者QQ: "QQ",
        "紧急联系人姓名（必填）": "EcName",
        紧急联系人电话: "EcTel",
        "风险等级（01=正常 02=低风险 03=中风险 04=高风险）请填写对应的数字":
          "RiskRating",
        住院病区: "Ward",
        住院天数: "Day",
        "出院日期（日期格式2020-09-25）": "DischargeDate",
        出院诊断: "DischargeDiagnosis",
        "出院方式（00=同意出院 01=自动出院 02=转院 03=逃逸出院）请填写对应的数字":
          "DischargeMode",
        主治医生: "AttendingDoctor",
        随访医生: "FollowUpDoctor",
        随机号: "RandomNumber",
        组别号: "GroupNumber",
        "患者来源（00=测试来源1 02=测试来源2 03=测试来源3）请填写对应的数字":
          "Source",
        患者地址: "Address",
      };
      return results.map((zhObj) => {
        // 首先创建一个空对象来逐个接收转换后的key
        const enObj = {};

        // 使用Object.keys方法来获取中文的key
        const zhKeys = Object.keys(zhObj); // ['姓名', '手机号']

        // 用forEach循环来将key逐个映射(map)出去
        zhKeys.forEach((zhKey) => {
          const enKey = mapInfo[zhKey]; // 如果是一个对象具体的某个属性,就用 对象.(属性),此处非确切值,则为 对象[属性] 写法

          enObj[enKey] = zhObj[zhKey]; // 将空对象所需要接收的值传入
        });

        return enObj;
      });
    },
    //导入
    getFile(e) {
      let fd = new FormData();
      fd.append("file", e.target.files[0]);
      fd.append("ProjectId", this.Pvalue);
      ProjectManagement.PatientExportData(fd).then((res) => {
        if (res.data.Status == 1) {
          this.$message({
            type: "success",
            message: res.data.Message,
          });
          this.ProjectList();
        } else {
          alert(res.data.Message);
        }
      });
    },
    //编辑
    Editfather(data) {
      this.PatientTable = this.PatientTable.map((item) => {
        if (item.Id == data.Id) {
          item = data;
        }
        return item;
      });
    },
    //新增患者
    Addfather(data) {
      this.PatientTable.unshift(data);
      this.ProjectGetPageList(this.value.Id);
    },
    //项目患者列表
    ProjectGetPageList(Id) {
      const parameter = {
        ...this.$route.query,
        ...this.listQuery,
      };
      WorkReport.GetPatientList(parameter).then((res) => {
        // if(res.data.Status==1){
        this.PatientTable = res.data.rows.map((item) => {
          item.CreateTime = item.CreateTime.substring(0, 10);
          if (item.Birthday) {
            item.Birthday = item.Birthday.substring(0, 10);
          }
          return item;
        });
        this.total = res.data.total;
        this.$nextTick(() => {
          this.activityMultipleSelection.forEach((row) => {
            this.PatientTable.forEach((p) => {
              if (p.Id == row.Id) {
                this.$refs.multipleTable.toggleRowSelection(p);
              }
            });
          });
        });
      });

    },
    //删除患者
    DeletePatient(row) {
      const parameter = [];
      parameter.push(row.Id);
      this.$confirm("删除后将无法恢复，请问你确定要删除该患者吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        PatientCenter.DeletePatientData(parameter).then((res) => {
          if (res.data.Status == 1) {
            this.PatientTable = this.PatientTable.filter((item) => {
              return item.Id != row.Id;
            });
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.ProjectGetPageList(this.value.Id);
          } else {
            alert(res.data.Message);
          }
        });
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "../../styles/mixin.scss";

/deep/ .el-link--inner {
  margin-right: 11px;
}

/deep/.el-table__fixed-right {
  right: 0px !important;
  background-color: #fff;
}

.classborder {
  border: 1px solid red;
}

.tag_span {
  display: inline-block;
  min-width: 80px;
  height: 26px;
  background-color: #409eff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  line-height: 24px;
  // color: #409eff;
  color: #fff;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 8px;
  margin-left: 4px;
  font-size: 12px;
}

.QuestionnaireFilling {
  /deep/.el-dialog__body {
    height: 94%;
    padding: 0;
  }

  /deep/.el-dialog__headerbtn {
    top: 8px;
  }
}

.span-h {
  cursor: pointer;
}

.QuestionnaireTable {
  width: 100%;
}

.el-select {
  width: 100%;
}

.QuestionnaireTable {
  /deep/.el-input__inner {
    // width: 100%;
    // min-width: 400px;
    // width: 540px;
    height: 40px;
    line-height: 40px;
  }

  /deep/.el-input {
    height: 40px;
  }
}

/deep/.el-input {
  height: 30px;
}

/deep/.el-input__inner {
  width: 100%;
  height: 30px;
}

/deep/.el-form-item__content {
  height: 34px;
}

/deep/.el-button {
  height: 34px;
  font-weight: 400;
  @include add-size5($font_size_14);
}

/deep/.el-button--primary {
  @include common_button_primary;
  margin-left: 20px;
}

/deep/.el-input__icon {
  line-height: 20px;
  width: 20px;
}

.tolead {
  width: 100%;
  height: 100%;
  min-width: 1440px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .title {
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .left {
      margin-top: 14px;
      margin-bottom: 1%;
      margin-left: 1%;
      width: 99%;
      display: flex;

      // justify-content: center;
      // align-items: center;
      .yuan {
        display: flex;
        align-items: center;
        height: 34px;
        // /deep/.el-tag {
        //   border-radius: 50% !important;
        //   width: 20px;
        //   height: 20px;
        //   vertical-align: middle;
        // }
        float: right;
        margin-right: 20px;

        span {
          @include common_span;
        }
      }

      span {
        display: inline-block;
        @include common_span;
        margin-left: 6px;
        margin-right: 6px;
      }

      /deep/.el-input__inner {
        height: 34px;
        line-height: 20px;
        border-radius: 4px;
        @include add-size($font_size_16);
      }

      /deep/.el-input {
        margin-right: 10px;
        // width: 200px;
        height: 34px;
      }

      /deep/.el-input__inner {
        height: 34px;
      }

      /deep/.el-button.czhi {
        @include common_button_plain;
      }
    }

    .right {
      width: 98%;
      margin: 0 auto 10px auto;
      display: flex;
      justify-content: space-between;

      //position: relative;
      /deep/.el-button.export-img-btn {
        @include common_button_plain;
      }

      /deep/.el-button.dao-ru {
        @include common_button_primary;

        img {
          vertical-align: 0;
        }
      }

      .se2 {
        display: none;
      }
    }
  }

  .wenid {
    .wenidselect {
      width: 300px;
      height: 30px;
    }
  }
}

.con {
  height: 86%;
  margin-bottom: 10px;

  /deep/.el-tag {
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }

  .fen-rigth {
    width: 40%;

    input {
      width: 30px;
      height: 26px;
      margin-left: 1%;
      margin-right: 1%;
      border: 0;
      text-align: center;
      border-radius: 10%;
      font-size: 16px;
    }

    .span1-rigth {
      color: rgb(19, 104, 171);
    }
  }
}

.content {
  height: 700px;
  padding-top: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  height: 100%;
}

.box1 {
  width: 50%;
  height: 40px;

  .box1-span1 {
    width: 36%;
    display: inline-block;
    text-align: right;
  }

  .box1-span2 {
    width: 56%;
    display: inline-block;
    margin-left: 2%;

    /deep/.el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 180px;
    }

    /deep/.el-input {
      width: 85%;
    }

    /deep/.el-input__inner {
      width: 97%;
      height: 28px;
    }

    /deep/.el-input__icon {
      line-height: 28px;
    }

    /deep/.el-radio-group .el-radio {
      width: 38px;

      .el-radio__label {
        padding-left: 4%;
      }
    }

    /deep/.el-radio {
      margin-right: 0;
    }

    /deep/#select {
      width: 104px;
    }

    /deep/#select1 {
      width: 104px;
    }
  }

  input {
    height: 26px;
    border-radius: 6px;
    outline: none;
  }
}

.box22 {
  width: 100%;

  .box1-span1 {
    width: 18%;
  }

  .box1-span2 {
    width: 80%;
    margin-left: 1%;

    input {
      width: 160px;
    }

    /deep/.el-input {
      width: 95%;
    }
  }
}

.box1btn {
  width: 94%;

  /deep/.el-button {
    margin-right: 1%;
    float: right;
  }
}

a {
  color: #3fbc39;
}

//.add_dialog {
//  /deep/.el-dialog{
//    .el-dialog__header {
//      margin-bottom: 0;
//    }
//    /deep/.el-form {
//    .el-input {
//        width: 360px;
//      }
//    .el-input__inner {
//        width: 360px;
//      }
//    .el-select {
//        .el-input__inner {
//          width: 360px;
//        }
//      }
//    }
//    .btn {
//      margin-top: 10px;
//    }
//  }
//}
.call-phone {
  /deep/.el-dialog {
    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      width: 0;
      height: 0;
      padding: 0;
    }
  }
}

/deep/.el-drawer {
  height: 100%;

  .el-drawer__header {
    padding: 0 20px 0 0;
    margin: 0;
  }

  .detailsDrawer-components {
    background: #f3f4f5;
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.16);
  }

  .header-title {
    width: 1201px;
    height: 60px;
    background: #ffffff;
    opacity: 1;
    line-height: 60px;
  }
}

/deep/.el-button.yijian {
  @include common_button_plain;
  background: rgba(57, 120, 231, 0.15);
  border: 1px solid rgba(51, 136, 255, 0.5686274509803921);
}

@media screen and (-webkit-min-device-pixel-ratio: 1.5) {
  .tolead {
    min-width: 0 !important;

    .title {
      /deep/.el-button--primary {
        margin-left: 0 !important;
        margin-right: 10px !important;
      }

      .left {
        flex-wrap: wrap;
        justify-content: space-between;

        .project {
          width: 150px !important;
          margin-right: 0 !important;
        }

        .timer {
          span {
            width: 40px !important;
          }

          /deep/.el-input {
            width: 143px !important;
          }
        }

        .KeyWord {
          width: 150px !important;

          /deep/.el-input {
            margin-right: 0 !important;
          }

          span {
            white-space: nowrap;
          }

          .el-input {
            width: none !important;
          }
        }

        .yuan {
          justify-content: flex-end;
          margin-right: 0 !important;
          width: 100% !important;
        }
      }
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;

      .con {
        height: 90% !important;

        /deep/.el-table__fixed-right-patch {
          width: 9px !important;
          background-color: rgb(240, 247, 253) !important;
        }
      }

      .robotVisibledia {
        width: 60% !important;
      }

      // /deep/.el-dialog{
      //
      // }

      .QuestionnaireTable {
        /deep/.el-dialog {
          width: 60% !important;
        }
      }
    }

    /deep/ .el-drawer {
      width: 100% !important;

      .detailsDrawer-components {
        height: 100%;

        .task-details-right {
          flex: 1;
        }
      }
    }
  }
}
</style>
  
  